import Form from '../../modules/core/forms/theme/js/Form';
import Utils from '../../modules/utils/utils-js/theme/js/utils/Utils';
import * as moment from 'moment';
import Panel from './Panel';
import Uploader from '../../modules/utils/uploader/theme/js/Uploader';

export default class Site {
    public static MOBILE_WIDTH = 992;

    public static Panel: Panel = Panel;

    public static onRegisterForm($uid: JQuery): void {
        new Form($uid);

        const $itype = $('input[name="type"]', $uid);

        const $ipersonal = $('.js-personal', $uid);
        const $icompany = $('.js-company', $uid);

        const setType = (type: string) => {
            $ipersonal.toggleClass('button--1', type == 'personal');
            $ipersonal.toggleClass('button--2', type != 'personal');
            $icompany.toggleClass('button--1', type == 'company');
            $icompany.toggleClass('button--2', type != 'company');

            $itype.val(type);

            $('.registerform__body', $uid).toggle(type != '');
            $('.registerform__company', $uid).toggle(type == 'company');
            $('.registerform__personal', $uid).toggle(type == 'personal');
        };

        $ipersonal.on('click', (e) => {
            setType('personal');
        });

        $icompany.on('click', (e) => {
            setType('company');
        });

        setType($itype.val());

        // Switcher.initVal(, 1, $('._js-forcompany', $uid));

        (<any>Site).discover($uid);
    }

    public static initFaq($uid: JQuery): void {
        const $items = $('.faq__item', $uid);

        const selectFunc = ($el: JQuery) => {
            const $sel = $el.hasClass('faq__item--selected') ? $() : $el;
            const $not = $items.not($sel);

            $sel.addClass('faq__item--selected');
            $not.removeClass('faq__item--selected');

            $('.faq__text', $sel).slideDown();
            $('.faq__text', $not).slideUp();
        };

        $items.each((ix, el) => {
            const $el = $(el);
            const $button = $('button', $el);

            $button.on('click', (e) => {
                selectFunc($el);
            });
        });
    }

    public static initMainSlider($mainslider: JQuery): void {
        const $slides = $('.mainslider__slides', $mainslider);

        const $_slick = (<any>$slides);

        $_slick.slick({
            infinity: true,
            dots: true,
            arrows: true,

            autoplay: true,
            autoplaySpeed: 2500,

            prevArrow: `<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>`,
            nextArrow: `<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>`,

            appendArrows: $('.mainslider__arrows', $mainslider),
            appendDots: $('.mainslider__dots', $mainslider),

            responsive: [
                {
                    breakpoint: 320,
                    settings: {
                        arrows: false,
                    }
                },
            ]
        });
    }

    public static onPageHome(): void {
    }

    public static discover($parent?: JQuery): void {
        Utils.updateElements($parent);

        Form.initRadios($('.vproduct .radio-items', $parent));

        (<any>$('.tooltipped', $parent)).tooltip();
    }

    private static updateFloat() {
        const top = $(window).scrollTop();

        const $body = $('body');

        $body.toggleClass('body--float', top > 0);
        $body.toggleClass('body--no-float', top == 0);
    }

    private static initGoTop(): void {
        const $gotop = $('.gotop');
        const $svg = $('svg', $gotop);

        const progressPath: any = <any>$('path', $svg)[0];

        var pathLength = progressPath.getTotalLength();
        progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
        progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
        progressPath.style.strokeDashoffset = pathLength;
        progressPath.getBoundingClientRect();
        progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';

        const updateProgress = () => {
            const scroll = $(window).scrollTop();
            const height = $(document).height() - $(window).height();
            const progress = pathLength - (scroll * pathLength / height);
            progressPath.style.strokeDashoffset = progress;
        }

        $(window).scroll(updateProgress);
        updateProgress();

        $(window).on('scroll', () => {
            $gotop.toggleClass('gotop--visible', $(window).scrollTop() > 100);
        });

        $gotop.toggleClass('gotop--visible', $(window).scrollTop() > 100);

        $gotop.on('click', (e) => {
            e.preventDefault();

            $('html, body').animate({ scrollTop: 0 }, 550);
        })
    }

    private static initMenus(): void {
        const $menu = $('.header__menu');
        const $mainmenubutton = $('.header__menu-button button', $menu);

        $mainmenubutton.on('click', () => {
            $menu.toggleClass('header__menu--opened');
        });
    }

    private static initHtml() {
        this.initMenus();
        this.initGoTop();

        this.discover();
    }

    private static initRwd() {
        $(window).resize(Site.updateFloat);
        $(window).scroll(Site.updateFloat);

        Site.updateFloat();
    }

    public static evalJs(): void {
        (<any>window)._js = (h: () => void) => {
            h();
        };

        let js = (<any>window)._jslist;

        $.each(js, (k, v) => {
            v();
        });
    }

    public static init() {
        moment.locale('pl');

        (<any>window).Site = Site;

        Form.init();
        Uploader.init();

        $(document).ready(() => {
            Site.initHtml();
            Site.initRwd();
        });

        $(window).on('load', () => {
            $('body').addClass('body--loaded');

            setTimeout(() => {
                $('body').removeClass('body--loading');
                $('body').trigger('pageloaded');
            }, 1000);
        });
    }
}

Site.init();
